<template>
	<div id="app">
		<navigation></navigation>
		<banner class="new-browser"/>
		<div class="old-browser">
			<p>
				It seems like you are using older broswer, some things might not work, we recommend using the 
				latest version of either <a href="https://www.google.com/chrome/" target="_blank" >
				<b>Google Chrome</b></a> or <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" >
				<b>Firefox</b></a>
			</p>
			<p>
				<center>
					<a href="https://www.google.com/chrome/" target="_blank" >
						<img src="./assets/img/png/icon_chrome.png" alt="Google Chrome" >
					</a>
					<a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" >
						<img src="./assets/img/png/icon_firefox.png" alt="Firefox" >
					</a>
				</center>
			</p>
		</div>
		<router-view class="content-stager" />
		<footer class="shadow-1">
			<div class="contacts">
				<div>
					<img src="./assets/img/svg/24px/call_24px.svg" width="24" height="24" alt="call"/>
					<p>(266) 22-311441<br />
					(266) 22-324814<br />
					(266) 5888 0159</p>
				</div>
				<div>
					<img src="./assets/img/svg/24px/email_24px.svg" width="24" height="24" alt="mail"/>
					<p>
						admin@dyelec.co.ls<br />
						P/Bag A409,
						MASERU 100
					</p>
				</div>
			</div>
			<div class="developer">
				<a href="https://itguy.maseru.co.ls/" target="_blank">
					developed by Tsepo Nkalai
				</a>
			</div>
		</footer>
	</div>
</template>

<script>
// @ is an alias to /src
	import banner from '@/components/Banner.vue';
	import navigation from '@/components/Nav';
	import emitter from '@/emitter';

	export default {
		name: 'App',
		metaInfo: {
			// if no subcomponents specify a metaInfo.title, this title will be used
			title: 'Dyelec Lesotho',
			// all titles will be injected into this template
			titleTemplate: 'Dyelec Lesotho | %s'
		},
		components: {
			navigation,
			banner
		},
		mounted() {
			document.querySelector('#app').addEventListener('scroll', this.trackTop);
			this.$router.afterEach(() => {
				if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768) {
					emitter.$emit('hide-menu');
				}
				setTimeout(() => {
					const bounding_rect_banner = document.querySelector('.banner').getBoundingClientRect();
					document.querySelector('#app').scrollTo({
						left: 0, 
						top: bounding_rect_banner.height + 8,
						behavior: 'smooth'
					});
				}, 500);
			});
			if(this.$route.query.route) {
				this.handleRouting(this.$route.query.route);
			}
		},
		methods: {
			trackTop() {
				if(document.querySelector('.content-stager').getBoundingClientRect().top <= 0) {
					document.querySelector('#app').removeEventListener('scroll', this.trackTop);
					emitter.$emit('stop-banner-animations');
				}
			},
			handleRouting(_route) {
				switch (_route) {
				case 'contacts':
					this.$router.push({
						path: '/contacts'
					});
					break;
				case 'projects':
					this.$router.push({
						path: '/projects'
					});
					break;
				case 'directors':
					this.$router.push({
						path: '/directors'
					});
					break;
				case 'home':
					this.$router.push({
						path: '/'
					});
					break;
				default:
					break;
				}
			}
		}
	};
</script>

<style lang="scss">
	@import './assets/style/main.scss';
	
	
	// /* roboto-100 - latin */
	// @font-face {
	// 	font-display: swap;
	// 	font-family: 'Roboto';
	// 	font-style: normal;
	// 	font-weight: 100;
	// 	src: url('./assets/fonts/roboto/roboto-v20-latin-100.eot'); /* IE9 Compat Modes */
	// 	src: local('Roboto Thin'), local('Roboto-Thin'),
	// 	url('./assets/fonts/roboto/roboto-v20-latin-100.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-100.woff2') format('woff2'), /* Super Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-100.woff') format('woff'), /* Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-100.ttf') format('truetype'), /* Safari, Android, iOS */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-100.svg#Roboto') format('svg'); /* Legacy iOS */
	// }

	// /* roboto-regular - latin */
	// @font-face {
	// 	font-display: swap;
	// 	font-family: 'Roboto';
	// 	font-style: normal;
	// 	font-weight: 400;
	// 	src: url('./assets/fonts/roboto/roboto-v20-latin-regular.eot'); /* IE9 Compat Modes */
	// 	src: local('Roboto'), local('Roboto-Regular'),
	// 	url('./assets/fonts/roboto/roboto-v20-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-regular.woff') format('woff'), /* Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-regular.svg#Roboto') format('svg'); /* Legacy iOS */
	// }

	// /* roboto-500 - latin */
	// @font-face {
	// 	font-display: swap;
	// 	font-family: 'Roboto';
	// 	font-style: normal;
	// 	font-weight: 500;
	// 	src: url('./assets/fonts/roboto/roboto-v20-latin-500.eot'); /* IE9 Compat Modes */
	// 	src: local('Roboto Bold'), local('Roboto-Bold'),
	// 	url('./assets/fonts/roboto/roboto-v20-latin-500.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-500.woff2') format('woff2'), /* Super Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-500.woff') format('woff'), /* Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-500.ttf') format('truetype'), /* Safari, Android, iOS */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-500.svg#Roboto') format('svg'); /* Legacy iOS */
	// }

	// /* roboto-700 - latin */
	// @font-face {
	// 	font-display: swap;
	// 	font-family: 'Roboto';
	// 	font-style: normal;
	// 	font-weight: 700;
	// 	src: url('./assets/fonts/roboto/roboto-v20-latin-700.eot'); /* IE9 Compat Modes */
	// 	src: local('Roboto Bold'), local('Roboto-Bold'),
	// 	url('./assets/fonts/roboto/roboto-v20-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-700.woff') format('woff'), /* Modern Browsers */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
	// 	url('./assets/fonts/roboto/roboto-v20-latin-700.svg#Roboto') format('svg'); /* Legacy iOS */
	// }



	html {
		scroll-behavior: smooth;
	}

	* {
		box-sizing: border-box;
	}
	#app {
		height: 100vh;
		overflow-x: hidden;
		overflow-y: scroll;
		perspective: 100px;
		perspective-origin: 50%;
		transform-style: preserve-3d;
		transform: translate3d(0px, 0px, 0px);
		
		.old-browser {
			display: block;
			margin-top: 4em;
			text-align: center;
			padding: 4em 1em;
			font-size: 1.3em;
			.text-color-firebrick {
				font-weight: 400;
				color: #7e2921 !important;
			}
			div {
				font-size: 1.5em;
				font-weight: 300;
			}
			a {
				color: $blue;
				text-decoration: underline;
				text-decoration-color: $blue;
			}
			@supports (position: sticky) {
				display: none !important;
			}
		}
		.new-browser {
			display: none;
			@supports  (position: sticky) {
				display: flex !important;
			}
		}
		.content-stager {
			padding-bottom: 1em;
		}
		footer {
			font-size: 0.9em;
			padding: 1em 1em 3em 1em;
			color: $white;
			background-color: $gray;
			display: block;

			.contacts {
				p {
					margin: 0px;
				}
				@media (min-width: 512px) {
					display: flex;
					align-items: flex-start;
				}

				div {
					@media (max-width: 511px) {
						p {
							margin-top: -1.8em;
							margin-left: 2.8em;
						}
						&:nth-of-type(n+2) {
							margin-top: 1em;
						}
					}
					@media (min-width: 512px) {
						display: flex;
						align-items: flex-start;
						&:first-of-type {
							padding-right: 2em;
							border-right-style: solid;
							border-right-width: 1px;
							border-right-color: rgba(255,255,255, 0.1);
						}
						&:last-of-type {
							padding-left: 1em;
						}
					
						p {
							margin: 0px;
							&:first-of-type {
								margin-top: 0.5em;
							}
						}

						&:nth-of-type(n+2) {
							margin-left: 1em;
						}
					}
					img {
						margin-right: 0.9em;
						opacity: 0.4;
					}
				}
			}
			.developer {
				margin-left: 2.7em;
				margin-top: 2em;
				color: $white;
				a {
					color: $white;
					text-decoration-color: rgba(255,255,255, 0.5);
				}
			}
		}
	}
		
	.view {
		position: relative;
		width: 100vw;
		min-height: calc(100vh - 32px);
		display: flex;
		flex-direction: column;
		align-items: stretch;
		z-index: 2;
		background-color: $blue-dark;

		
		position: relative;
		
	}
	
	.modal {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100vw;
		min-height: 100%;
		background-color: $blue-dark;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-content: flex-start;
		justify-content: flex-start;
		padding: 1em;
	}

	@media screen and (max-width: 767px) {
	}
	@media screen and (min-width: 768px) {

			
	}
</style>
